export enum CodeEditorLanguage {
  Plaintext = 'plaintext',
  Abap = 'abap',
  Apex = 'apex',
  Azcli = 'azcli',
  Bat = 'bat',
  Bicep = 'bicep',
  Cameligo = 'cameligo',
  Clojure = 'clojure',
  Coffeescript = 'coffeescript',
  C = 'c',
  Cpp = 'cpp',
  Csharp = 'csharp',
  Csp = 'csp',
  Css = 'css',
  Cypher = 'cypher',
  Dart = 'dart',
  Dockerfile = 'dockerfile',
  Ecl = 'ecl',
  Elixir = 'elixir',
  Flow9 = 'flow9',
  Fsharp = 'fsharp',
  Freemarker2 = 'freemarker2',
  Go = 'go',
  Graphql = 'graphql',
  Handlebars = 'handlebars',
  Hcl = 'hcl',
  Html = 'html',
  Ini = 'ini',
  Java = 'java',
  Javascript = 'javascript',
  Julia = 'julia',
  Kotlin = 'kotlin',
  Less = 'less',
  Lexon = 'lexon',
  Lua = 'lua',
  Liquid = 'liquid',
  M3 = 'm3',
  Markdown = 'markdown',
  Mdx = 'mdx',
  Mips = 'mips',
  Msdax = 'msdax',
  Mysql = 'mysql',
  ObjectiveC = 'objective-c',
  Pascal = 'pascal',
  Pascaligo = 'pascaligo',
  Perl = 'perl',
  Pgsql = 'pgsql',
  Php = 'php',
  Pla = 'pla',
  Postiats = 'postiats',
  Powerquery = 'powerquery',
  Powershell = 'powershell',
  Proto = 'proto',
  Pug = 'pug',
  Python = 'python',
  Qsharp = 'qsharp',
  R = 'r',
  Razor = 'razor',
  Redis = 'redis',
  Redshift = 'redshift',
  Restructuredtext = 'restructuredtext',
  Ruby = 'ruby',
  Rust = 'rust',
  Sb = 'sb',
  Scala = 'scala',
  Scheme = 'scheme',
  Scss = 'scss',
  Shell = 'shell',
  Sol = 'sol',
  Aes = 'aes',
  Sparql = 'sparql',
  Sql = 'sql',
  St = 'st',
  Swift = 'swift',
  Systemverilog = 'systemverilog',
  Verilog = 'verilog',
  Tcl = 'tcl',
  Twig = 'twig',
  Typescript = 'typescript',
  Vb = 'vb',
  Wgsl = 'wgsl',
  Xml = 'xml',
  Yaml = 'yaml',
  Json = 'json',
}
